module.exports = __webpack_public_path__ + "static/img/RAC166M_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC166M_1.png
// module id = wtGY
// module chunks = 0